import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

interface MultilineTextFieldProps {
  text?: string;
  label?: string;
  fontSize?: string;
  color?: string;
  fontWeight?: string;
  lineHeight?: string;
  marginTop?: string;
  marginBottom?: string;
  showLabel?: boolean;
  labelStyle?: React.CSSProperties;
  textStyle?: React.CSSProperties;
}

export const MultilineTextField: React.FC<MultilineTextFieldProps> = ({
  text,
  label,
  fontSize = '13px',
  color = '#262626',
  fontWeight = 'normal',
  lineHeight = '1.4',
  marginTop = '2px',
  marginBottom = '0px',
  showLabel = true,
  labelStyle = {},
  textStyle = {},
}) => {
  // Helper function to render text with line breaks
  const renderTextWithLineBreaks = (text: string) => {
    if (!text) return '-';

    // Handle multiple levels of escaping by recursively replacing \\n with \n
    // This ensures clean display even if data wasn't cleaned at the provider level
    let processedText = text;
    while (processedText.includes('\\n')) {
      processedText = processedText.replace(/\\n/g, '\n');
    }

    return processedText.split('\n').map((line, index) => (
      <div
        key={index}
        style={{
          marginBottom:
            index < processedText.split('\n').length - 1 ? '2px' : '0',
        }}
      >
        {line || '\u00A0'} {/* Use non-breaking space for empty lines */}
      </div>
    ));
  };

  return (
    <div>
      {showLabel && label && (
        <Text
          strong
          style={{
            fontSize: '12px',
            color: '#595959',
            ...labelStyle,
          }}
        >
          {label}:
        </Text>
      )}
      <div
        style={{
          fontSize,
          color,
          fontWeight,
          lineHeight,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          marginTop: showLabel && label ? marginTop : '0px',
          marginBottom,
          ...textStyle,
        }}
      >
        {renderTextWithLineBreaks(text || '')}
      </div>
    </div>
  );
};

export default MultilineTextField;
